/**
 * 多语言
 * */
import Setting from "@/config/index";
import Cookies from "js-cookie";
const savedLocaleKey = Setting.i18n.cookieLable;

export default {
  namespaced: true,
  state: {
    locale: ""
  },
  actions: {
    /**
     * @description 获取当前语言
     * */
    getLocale({ state }) {
      let locale;
      // const savedLocale = localStorage.getItem(savedLocaleKey);
      const savedLocale = Cookies.get(savedLocaleKey);

      // 先判断本地存储是否已有语言选择
      if (!!savedLocale) {
        locale = savedLocale;
      } else {
        // 判断是否开启自动识别语言
        locale = Setting.i18n.default;
        // localStorage.setItem(savedLocaleKey, locale);
        Cookies.set(savedLocaleKey, locale, {domain:"iccec.cn"});
      }
      state.locale = locale;
    },
    /**
     * @description 设置当前语言
     * */
    setLocale({ state }, { locale = Setting.i18n.default, vm }) {
      // localStorage.setItem(savedLocaleKey, locale);
      Cookies.set(savedLocaleKey, locale, {domain:"iccec.cn"});
      // 设置当前语言
      state.locale = locale;
      // 设置 vue-i18n 的语言
      // vm.$i18n.locale = locale;
      // 更新网页标题
      // util.title({
      //   title: vm.$route.meta.title
      // });
    }
  }
};
